import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: resolve => require(['../views/Index/Index.vue'],resolve),
    children: [
      // { path: "", component: resolve => require(['../views/page404/Index.vue'],resolve) },
      // { path: "", component: resolve => require(['../views/CourseHome/Index.vue'],resolve) },
      { path: "", component:  resolve => require(['../views/home/Index.vue'],resolve)},
      { path: "/VirtualReg",  component: resolve => require(['../views/VirtualReg/Index.vue'],resolve) },
      { path: "/virtualAdmin", component:  resolve => require(['../views/VirtualAdmin/Index.vue'],resolve) },
      { path: "/About", component:  resolve => require(['../views/About/Index.vue'],resolve)  },
      { path: "/UserHelp", component:  resolve => require(['../views/UserHelp/Index.vue'],resolve)  },
      { path: "/Article", component:  resolve => require(['../views/Article/Index.vue'],resolve)  },
      { path: "/ArticleDetail", component:  resolve => require(['../views/ArticleDetail/Index.vue'],resolve) },
      {
        path: "/course",
        name: "course",
        component: resolve => require(['../views/Course/Index.vue'],resolve) ,
        children: [
          { path: "", component: resolve => require(['../views/Course/CourseList/Index.vue'],resolve) },
          { path: "/courseDetail", component: resolve => require(['../views/Course/CourseDetail/Index.vue'],resolve) },
        ]
      }
    ]
  },
  {
    path: "/adminCase",
    name: "adminCase",
    component: resolve => require(['../views/AdminCase/Index.vue'],resolve),
  },
  {
    path: "/caseList",
    name: "caseList",
    component: resolve => require(['../views/caseList/Index.vue'],resolve),
  },
  {
    path: "/chrome",
    name: "chrome",
    component: resolve => require(['../views/Chrome/Index.vue'],resolve),
  },
  // {
  //   path: "/siteUs",
  //   name: "siteUs",
  //   component: resolve => require(['../views/SiteUs/Index.vue'],resolve),
  // },
  {
    path: "/siteUsV2",
    name: "siteUsV2",
    component: resolve => require(['../views/SiteUsV2/Index.vue'],resolve),
  },
  {
    path: "/siteAu",
    name: "siteAu",
    component:  resolve => require(['../views/SiteAu/Index.vue'],resolve),
  },
  {
    path: "/siteUk",
    name: "siteUk",
    component:  resolve => require(['../views/SiteUk/Index.vue'],resolve),
  },
  {
    path: "/siteJp",
    name: "siteJp",
    component:  resolve => require(['../views/SiteJp/Index.vue'],resolve),
  },
  {
    path: "/siteJpNew",
    name: "siteJpNew",
    component:  resolve => require(['../views/SiteJpNew/Index.vue'],resolve),
  },
  {
    path: "/siteAe",
    name: "siteAe",
    component:  resolve => require(['../views/SiteAe/Index.vue'],resolve),
  },
  {
    path: "/siteSg",
    name: "siteSg",
    component:  resolve => require(['../views/SiteSg/Index.vue'],resolve),
  },
  {
    path: "/SiteNew",
    name: "SiteNew",
    component:  resolve => require(['../views/SiteNew/Index.vue'],resolve),
  },
  {
    path: "/SiteAll",
    name: "SiteAll",
    component:  resolve => require(['../views/SiteAll/Index.vue'],resolve),
  },
  {
    path: "/SiteNewUs",
    name: "SiteNewUs",
    component:  resolve => require(['../views/SiteNewUs/Index.vue'],resolve),
  },
  {
    path: "/SiteNewUk",
    name: "SiteNewUk",
    component:  resolve => require(['../views/siteNewUk/Index.vue'],resolve),
  },
  {
    path: "/siteIn",
    name: "siteIn",
    component:  resolve => require(['../views/SiteIn/Index.vue'],resolve),
  }
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});
// 去除路由重复错误
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default router;
